module.exports = __webpack_public_path__ + "img/zuijia_28.d52e87a2.png";